const donationInputs = [
   { name: "firstName", placeholder: "imię" },
   { name: "lastName", placeholder: "nazwisko" },
   { name: "email", placeholder: "e-mail" },
   { name: "amount", placeholder: "kwota darowizny (zł)" },
   { name: "agreement", placeholder: "" },
];
export default donationInputs;
